import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { UiNodeSpec } from './UiNodeSpec';

export const attributeMaterialLinkUiNodeSpec: UiNodeSpec<'attributeMaterialLink'> = {
    suppressNode: true,
    requiredSockets: 'all',
    cfg: () => ({ controlValues: { attributeId: '' }, id: getUID(), kind: 'attributeMaterialLink', disabled: false }),
    controls: getNodeCfg => ({
        attributeId: { cfg: { kind: 'createMaterial.attributes' }, nodeCfg: getNodeCfg(), value: getNodeCfg().controlValues.attributeId },
    }),
    inputs: nodeCfg => ({
        trigger: { socket: 'event', label: 'Trigger' },
        materialId: {
            control: {
                cfg: { kind: 'text', nullable: true },
                nodeCfg,
                nullable: true,
                value: nodeCfg.socketDefaults?.inputs?.materialId,
            },
            socket: 'string',
            label: 'Material ID',
        },
    }),
    kindLabel: 'Attribute Material Link',
    nodeCategory: 'argonautApi',
    outputs: () => ({ next: { socket: 'event', label: 'Next' } }),
    validator: node => {
        const errors: Record<string, string> = {};
        if (!node.controlValues.attributeId) {
            errors.attributeId = 'Attribute ID is required';
        }

        return Object.keys(errors).length ? errors : true;
    },
};
